import { HeaderSearchSelection } from '@upright/common/model/search/types';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import styled from 'styled-components';
import { FeatureId } from '../../../../../../../../../../common/iam/access/feature-access/types';
import { ModelEntityType } from '../../../../../../../../../../common/model/input/types';
import { restrictedPortfoliosText } from '../../../../../../../../../untidy/text-elements';
import { BouRadioButtonWithLabel } from '../../../../../../../../generic/components/inputs/bou-radio-button-with-label';
import { useHasAccessToFeature } from '../../../../../../../../generic/hooks';
import { Props } from './types';
import QuestionMark from '@upright/ui/common/generic/components/icons/octicons/octicon-question-16.svg';
import { TippyWithOriginalStyles } from '@upright/ui/common/generic/components/tooltips/default-tippy';

interface ButtonProps extends Props {
  text: string;
  type: HeaderSearchSelection;
}

export function FilterRadioButton(props: ButtonProps) {
  const { filter, type } = props;
  const extendedAccess = useHasAccessToFeature(FeatureId.SEARCHBAR);
  const restricted = getRestrictedContentText(type);
  const disabled = restricted && !extendedAccess;

  const button = (
    <BouRadioButtonWithLabel
      color={BouColor.PLATFORM_TEXT_WHITE}
      backgroundfillcolor={BouColor.PLATFORM_BG_GRAY}
      disableHover
      label={props.text}
      radioSize="1.2em"
      checked={filter === type}
      disabled={disabled}
      onSelect={() => {
        props.onFilterChange(props.type);
      }}
    />
  );

  const main = disabled ? (
    <TippyWithOriginalStyles
      interactive={true}
      trigger={'click'}
      placement={'bottom'}
      content={getRestrictedContentText(props.type)}
    >
      <span style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'nowrap' }}>
        {button}
        <QuestionMark style={{ fill: BouColor.PLATFORM_ICON_WHITE }} />
      </span>
    </TippyWithOriginalStyles>
  ) : (
    button
  );

  return <ButtonRoot>{main}</ButtonRoot>;
}

const ButtonRoot = styled.div``;

function getRestrictedContentText(type: HeaderSearchSelection | undefined) {
  if (!type) {
    return;
  }
  switch (type) {
    case ModelEntityType.PORTFOLIO:
      return restrictedPortfoliosText;
    default:
      return undefined;
  }
}
